import List from "./features/List";
import Filter from "./features/Filter";
import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {useReadTaxList} from "./hooks/useReadTaxList";
import {TaxInvoiceListElementType, TaxInvoiceSearchParamType} from "./interface";
import {taxInvoiceListMapInit, taxInvoiceSearchParamInit} from "./state";
import moment from "moment/moment";
import {useModal} from "../../../hooks";
import {useQueryClient} from "@tanstack/react-query";
import {useUpdateTaxIssueDateBulk} from "./hooks/useUpdateTaxIssueDateBulk";

export default function TaxInvoice() {
    const page = Number(useSearchParams()[0].get("pageNo")) || 1;
    const {handleModal} = useModal();
    const qc = useQueryClient();

    const [searchParam, setSearchParam] = useState<TaxInvoiceSearchParamType>((() => ({
        ...taxInvoiceSearchParamInit,
        fromDate: moment().subtract(1, "months").startOf("months").format("YYYY-MM-DD"),
        toDate:  moment().endOf("month").format("YYYY-MM-DD"), // 당월 말일
    }))())
    const [selectedItems, setSelectedItems] = useState<TaxInvoiceListElementType[]>([])
    const {data: tax} = useReadTaxList({param: searchParam});

    // 내부수정: 발행일자 일괄 적용
    const [issueDate, setIssueDate] = useState<string>(moment().endOf("month").format("YYYY-MM-DD"))
    const {mutateAsync: mutateAsyncUpdateIssueDate} = useUpdateTaxIssueDateBulk()

    const btnApplyIssueDate = () => {
        const callback = () => {
            const taxIds = selectedItems.map(el => el.newShipmentTaxId)

            mutateAsyncUpdateIssueDate({taxIds, issueDate}).then(res => {
                if (res.data.code === "0000") {
                    handleModal({
                        isOpen: true,
                        contents: "적용되었습니다",
                        type: "alert",
                    });

                    qc.invalidateQueries({queryKey: ["readTaxList"]})
                    setSelectedItems([])
                } else {
                    handleModal({
                        isOpen: true,
                        contents: res.data.msg,
                        type: "alert",
                    });
                }
            })
        }

        if (selectedItems.length === 0) {
            handleModal({
                isOpen: true,
                contents: "항목을 선택해주세요.",
                type: "alert",
            });
        } else {
            handleModal({
                isOpen: true,
                contents: "적용하시겠습니까?",
                type: "confirm",
                callback: () => callback()
            });
        }
    }

    useEffect(() => {
        setSearchParam({...searchParam, pageNo: page})
    }, [page]);

    return <>
        <Filter searchParam={searchParam}
                setSearchParam={setSearchParam}
                setSelectedItems={setSelectedItems}
                selectedItems={selectedItems}
                issueDate={issueDate}
                setIssueDate={setIssueDate}
                btnApplyIssueDate={btnApplyIssueDate}/>

        <List tax={tax ?? taxInvoiceListMapInit}
              selectedItems={selectedItems}
              setSelectedItems={setSelectedItems}/>
    </>

}